import { ResetReduxLogData } from './redux-logging-action-types'
import {
  ReduxLoggingState,
  ReduxLoggingTypeEnum,
} from './redux-logging-reducer'

export const getReduxLogsData = (state: ReduxLoggingState) => {
  const res: Array<{
    shouldBeSentToRollbar: boolean | undefined
    message: string
    resetReduxLogPayload: ResetReduxLogData<ReduxLoggingTypeEnum>['payload']
  }> = []
  Object.entries(state.logData).forEach(([logType, obj]) => {
    switch (logType) {
      case ReduxLoggingTypeEnum.ROOT_MASTER_BLOCK_ENTITIES_LOST_MASTER_BLOCK_ID:
        Object.values(obj).forEach(
          ({ masterBlockId, shouldBeSentToRollbar }) => {
            res.push({
              shouldBeSentToRollbar,
              message: `The master block (${masterBlockId}) has at least one entity without the masterBlockId`,
              resetReduxLogPayload: {
                logType,
                data: {
                  masterBlockId,
                },
              },
            })
          },
        )
        break
      default:
        break
    }
  })
  return res
}

export const getReduxLogs = (state: ReduxLoggingState) => {
  return state.logs
}

const reduxLoggingSelectors = {
  getReduxLogsData,
  getReduxLogs,
}

export default reduxLoggingSelectors
